export const names = {
  precision_policy: 'Precision Policy'
};
